import type { EngineInfo } from "../api/models";

/** Models and prompts only: a newer scan-core is a release, not a custom run. */
const sameEngine = (a: EngineInfo, b: EngineInfo) =>
  a.identify === b.identify &&
  a.pricePicker === b.pricePicker &&
  JSON.stringify(a.prompts) === JSON.stringify(b.prompts);

/** The engine line of a run; opens to the prompts it ran with. */
export function EngineDetails({ engine, defaults }: { engine: EngineInfo; defaults?: EngineInfo | null }) {
  // A run recorded before prompts were kept cannot be told apart from a default one.
  const custom = defaults && engine.prompts ? !sameEngine(engine, defaults) : false;
  return (
    <details className="engine-details">
      <summary className="mono muted">
        {engine.scanCore} · {engine.identify} · {engine.pricePicker}
        {custom && <span className="badge badge-wrong_pick"> custom</span>}
        {engine.prompts && <span className="muted"> ▾</span>}
      </summary>
      <div className="prompts">
        <h4>Models</h4>
        <div className="mono">
          identify {engine.identify} · price picker {engine.pricePicker} · scan-core {engine.scanCore}
        </div>
        {engine.prompts ? (
          <>
            <h4>Identify prompt</h4>
            <pre>{engine.prompts.identify}</pre>
            {Object.entries(engine.prompts.price).map(([type, prompt]) => (
              <div key={type}>
                <h4>Price picker prompt · {type}</h4>
                <pre>{prompt}</pre>
              </div>
            ))}
          </>
        ) : (
          <p className="muted">This run predates prompt recording.</p>
        )}
      </div>
    </details>
  );
}
